/** * @71281 - Cadastro de Tipo de ocorrência */
<template>
    <div id="main">
        <div class="page">
            <div class="tipos-servicos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('agro-tipoocorrencia') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('agro') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('agro-tipoocorrencia') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="!integracao && permissao.create"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'agro-tipoocorrencia-new' })"
                        >
                            {{ $t('adicionar') }}
                        </button>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-9">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            tooltipLabel="msg-campo-busca-ocorrencia"
                        />
                    </div>

                    <div class="column is-3">
                        <vss-select
                            :id="generateId(2)"
                            ref="situacaoInput"
                            title="situacao"
                            :options="situacaoSelect"
                            :mlLabels="true"
                            @input="onSituacaoChanged"
                            v-model="situacaoSelected"
                            :height="40"
                            :clearable="true"
                        />
                    </div>
                </div>
                <div class="registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="tipoocorrencias"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="
                                (f.key != 'excluir' ? $t(f.key) : '') &&
                                (f.key != 'imagem' ? $t(f.key) : $t('pin'))
                            "
                            :width="f.width"
                            :class="{
                                'excluir-field': f.key == 'excluir',
                                'label-km': f.key == 'label',
                            }"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'descricao' || f.key == 'codigo'">
                                <router-link
                                    v-if="permissao.read"
                                    :to="{
                                        name: 'agro-tipoocorrencia-edit',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                                <span v-else>{{ props.row[f.key] }}</span>
                            </div>
                            <div v-else-if="f.key == 'cor'">
                                <div
                                    class="color-block"
                                    :style="{ 'background-color': props.row[f.key] }"
                                ></div>
                            </div>
                            <div v-else-if="f.key == 'icone'">
                                <!--gerando html com v-html par icones dinamicos -->
                                <span
                                    v-if="!cleanHide"
                                    v-html="buildIcon(props.row[f.key])"
                                    ref="icone"
                                    class="icon has-text-dark"
                                >
                                </span>
                            </div>
                            <div v-else-if="f.key == 'imagem'">
                                <!--gerando html com v-html par icones dinamicos -->
                                <span
                                    v-if="!cleanHide"
                                    v-html="buildIcon(props.row[f.key])"
                                    ref="imagem"
                                    class="icon has-text-dark"
                                >
                                </span>
                            </div>
                            <div v-else-if="f.key == 'excluir'">
                                <span v-if="permissao.delete && !integracao">
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy
                                        :title="
                                            $t(
                                                props.row['situacao'] == 1
                                                    ? 'desativar'
                                                    : 'reativar'
                                            )
                                        "
                                    />
                                </span>
                            </div>
                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-if="props.row[f.key] == 1"
                                    type="is-success"
                                    size="is-medium"
                                    >{{ $t('ativo') }}</b-tag
                                >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-else
                                    type="is-danger"
                                    size="is-medium"
                                    >{{ $t('inativo') }}</b-tag
                                >
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import TipoOcorrenciaService from '@/services/agro/ocorrencia/TipoOcorrenciaService';
import { mapState } from 'vuex';

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            cleanHide: false,
            integracao: this.$store.state.user.tabelasERPWebServer.includes('AGRO_TIPOOCORRENCIA'),
            tipoocorrencias: [],
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacaoSelected: { id: 2, label: 'todos' },
            service: new TipoOcorrenciaService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'cor', width: null, sortable: false, sortFn: null },
                { key: 'icone', width: null, sortable: false, sortFn: null },
                { key: 'imagem', width: null, sortable: false, sortFn: null },
                { key: 'situacao', width: 70, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: '',
            column: 'id',
            order: 'asc',
            page: 1,
            situacao: 2,
            params: '',
            limit: 1,
            permissao: {},
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-tipoocorrencia');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-tipoocorrencia' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        load() {
            this.service
                .findAll(
                    this.column,
                    this.order,
                    this.page,
                    this.limit,
                    this.situacao,
                    ...this.params
                )
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`Erro com status ${r.status} ao realizar pesquisa.`);
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisaca.`, e);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            let params = [this.queryFilter != '' ? this.queryFilter : '.*'];
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.tipoocorrencias = value;
                    this.isEmpty = this.tipoocorrencias.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.load();
                    this.isLoading = false;
                    this.cleanHide = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.idagro_tipoocorrencia,
                    codigo: m.idagro_tipoocorrenciaerp,
                    descricao: m.descricao,
                    cor: m.cor,
                    icone: m.icone.toLowerCase(),
                    imagem: m.imagem.toLowerCase(),
                    situacao: m.situacao,
                    excluir: 'excluir',
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        buildIcon(icon) {
            return `<i class="fa-lg ${icon}"></i>`;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-desativar-tipoocorrencia'
                    : 'msg-erro-ao-reativar-tipoocorrencia';

            let temptipoocorrencia = {
                idagro_tipoocorrencia: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(temptipoocorrencia)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-ocorrencia'
                                : 'msg-sucesso-ao-desativar-ocorrencia';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
}
</style>
